import React, { createContext } from "react";

const entityContext = createContext({
  entityId: null,
  setEntityId: () => {},
});

const EntityContextProvider = ({ children }) => {
  const [entityId, setEntityId] = React.useState(null);
  return (
    <entityContext.Provider value={{ entityId, setEntityId }}>
      {children}
    </entityContext.Provider>
  );
};

const useEntityContext = () => {
  return React.useContext(entityContext);
};

export { EntityContextProvider, useEntityContext };
